<div class="d-flex gap-3 align-items-center">
    <div class="flex-grow-1">
        <hr class="m-0">
    </div>
    <h3 class="text-primary">
        <i class="pe-1" [ngClass]="[icon]"></i> {{text}}
    </h3>
    <div class="flex-grow-1">
        <hr class="m-0">
    </div>
</div>